import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Box, Typography, Paper , TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
  ListItem,
  ListItemText,
  List,
  Divider,
  Select,
  MenuItem,
  FormControl} from '@mui/material';
import ProgressDoh from './Chart/ProgressDoh';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import OrderTable from './Chart/OrderTable';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useParams } from 'react-router-dom';
import AdminBar from './AdminBar';
import {getDocs, serverTimestamp } from "firebase/firestore";
import { db } from '../../firebase';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import TicketView from './TicketView'
import IdleTimer from 'react-idle-timer';
import InactivityModal from './Inactive';
import PieChart from './Chart/PieChart';
import LineChart from './Chart/LineChart';
import ReportTable from './Chart/ReportTable';
import AdminStats from './Chart/AdminStats'
import BackToTopButton from './BackToTopButton';
import Templates from './Templates';
import EmailTemp from './EmailTemp';
import OtherTemp from './OtherTemp';
import NotTemp from './NotTemp';
import DownloadPage from './Download';
import Feedbacks from './Chart/Feedbacks';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'transparent',
  },
   root2: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
}));

const columns = [
  { id: 'ticketId', label: 'Ticket ID', minWidth: 100 },
  { id: 'subject', label: 'Subject', minWidth: 100 },
  { id: 'firstName', label: 'First Name', minWidth: 100 },
  { id: 'date', label: 'Date', minWidth: 100 },
  { id: 'oldestCall', label: 'Oldest Call', minWidth: 100 },
  { id: 'status', label: 'Status', minWidth: 100 },
  { id: 'admin', label: 'Admin', minWidth: 100 },
  { id: 'adminAction', label: 'Action', minWidth: 100 },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Dashboard() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  let {id} = useParams()
  const [name, setName] = useState()
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tickets, setTickets] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView]= useState(false)
  const [selected, setSelected] = useState([])
  const [activities, setActivities] = useState([]);
  const [tab, setTab] = React.useState(0);
  const [temp, setTemp] = useState(0)
  const [selectedFilter, setSelectedFilter] = useState('ticketId');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleAddData = async () => {
   db.collection("tickets").add({
      ticketId: "TR002",
      subject: "payment",
      firstName: "john",
      date: new Date().toLocaleString(),
      oldestCall: 10,
      status: "open"
    });
  }
useEffect(() => {
  db.collection('users').doc(id).get().then(function (snapshot){
    setName(snapshot.data().name)
  })
  db.collection('activities/'+id+'/list').onSnapshot((snapshot)=>{
  let cald = [];
        snapshot.forEach(snap => {
            cald.push(snap.data());
        });
        setActivities(cald) 
  })
  const fetchData = async () => {
      const ticketRef = db.collection('tickets');
     ticketRef.onSnapshot((querySnapshot) => {
      const ticketsArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTickets(ticketsArray);
    });
    };
    fetchData();
}, [])
const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    setSearchTerm('');
  };

  const filteredTickets = tickets.filter((ticket) => {
    const value = ticket[selectedFilter];
    return String(value).toUpperCase().includes(String(searchTerm).toUpperCase());
  });
  return (
    <div>
    <AdminBar id={id}/>
    <InactivityModal/>
    <div style={{display:'flex',width:'100%',alignItems:'center',justifyContent:'center',marginTop:'2rem'}}>
 <Paper style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center'}}>
       <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" >
        <Tab label="Home" {...a11yProps(0)} />
        <Tab label="Queue" {...a11yProps(1)} />
        <Tab label="Feedback" {...a11yProps(2)} />
        <Tab label="Data Optimization" {...a11yProps(3)} />
        <Tab label="Templates" {...a11yProps(4)} onClick={()=>setTemp(0)}/>
        <Tab label="Notification" {...a11yProps(5)} />
      </Tabs>
    </Paper>
    </div>
   <div>
          <TabPanel value={value} index={0}>
        <Typography align='center' variant='h6'>WELCOME {String(name).toUpperCase()}</Typography>
        <Paper>
          <div style={{display:'flex',justifyContent:'space-between', padding:'1rem'}}>
          <Typography>Your Recent Activities</Typography>
          <TextField
            type='date'
          />
          </div>
          {
            activities.length==0?
            <div style={{display:'flex',justifyContent:'center'}}>
           <div>
             <TaskAltIcon
              style={{fontSize:'10rem', color:'green'}}
            />
            <br/>
            <b>You have no activity</b>
           </div>
          </div>
          :
          activities.map((data)=>{
            return(
              <List>
          <ListItem button >
            <ListItemText primary={data.message} secondary={data.date}/>
          </ListItem>
         <Divider/>
        </List>
            );
          })
          }
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Typography align='center' variant='h6'>WELCOME {String(name).toUpperCase()}</Typography>
        {
          !view?
          <Paper className={classes.root} style={{padding:'1rem'}}>
       <div style={{display:'flex',justifyContent:'center'}}>
        <TextField
          id="search"
          label="Search"
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <FormControl>
          <Select
            labelId="filter-label"
            id="filter"
            value={selectedFilter}
            onChange={handleFilterChange}
          >
            <MenuItem value="ticketId">Ticket ID</MenuItem>
            <MenuItem value="firstName">Name</MenuItem>
            <MenuItem value="subject">Subject</MenuItem>
          </Select>
        </FormControl>
      </div>
      
      {/*<Button variant="contained" onClick={handleAddData}>Add 10 Data</Button>*/}
<TableContainer className={classes.container}>
<Table stickyHeader aria-label="sticky table">
<TableHead>
<TableRow>
{columns.map((column) => (
<TableCell
key={column.id}
align="left"
style={{ minWidth: column.minWidth }}
>
{column.label}
</TableCell>
))}
</TableRow>
</TableHead>
<TableBody>
{filteredTickets
.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
.map((ticket) => {
return (
<TableRow hover role="checkbox" tabIndex={-1} key={ticket.id}>
{columns.map((column) => {
const value = ticket[column.id];
return (
<TableCell key={column.id} align="left" 
onClick={()=>{
  setSelected(ticket)
  db.collection('activities/'+id+'/list').add({
    message:'You viewed '+ticket.ticketId,
    unix: Date.now(),
    date: new Date().toLocaleString(),
    stamp: serverTimestamp()
  })
  setView(true)
  }}>
{column.id=='oldestCall'?
value>=15? <p style={{color:'red'}}>{value} mins</p>:<p>{value} mins</p>
:column.id=='adminAction'?<RemoveRedEyeIcon 

  />:value}
</TableCell>
);
})}
</TableRow>
);
})}
</TableBody>
</Table>
</TableContainer>
<TablePagination
rowsPerPageOptions={[10, 25, 100]}
component="div"
count={tickets.length}
rowsPerPage={rowsPerPage}
page={page}
onPageChange={handleChangePage}
onRowsPerPageChange={handleChangeRowsPerPage}
/>
</Paper>
:
<TicketView ticket={selected} onClose={()=>{setView(false)}}/>
        }
        
      </TabPanel>
      <TabPanel value={value} index={2}>
         <Typography align='center' variant='h6'>WELCOME {String(name).toUpperCase()}</Typography>
         <Feedbacks/>
         
      </TabPanel>
      <TabPanel value={value} index={3}>
         <Typography align='center' variant='h6'>WELCOME {String(name).toUpperCase()}</Typography>
          <div style={{display:'flex',gap:'2rem'}}>
           <Paper
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <List>
          <ListItem button style={tab==0?{background:'#c7a936',color:'white'}:{background:'',color:'black'}} onClick={()=>{setTab(0)}}>
            <ListItemText primary="Reporting & Analytics" />
          </ListItem>
          <ListItem button style={tab==1?{background:'#c7a936',color:'white'}:{background:'',color:'black'}} onClick={()=>{setTab(1)}}>
            <ListItemText primary="View Report" />
          </ListItem>
          <ListItem button style={tab==2?{background:'#c7a936',color:'white'}:{background:'',color:'black'}} onClick={()=>{setTab(2)}}>
            <ListItemText primary="Download Report" />
          </ListItem>
        </List>
      </Paper>
      <Paper style={{width:'100%',padding:'1rem',borderRadius:'1rem'}}>
      {
        tab==0?
        <div>
        <div style={{display:'flex', gap:'2rem',width:'100%'}}>
          <PieChart/>
          <LineChart/>
        </div>
        <br/>
        <Typography variant='h6' align='center'>Average handle time</Typography>
        <AdminStats/>
        </div>
        
        :tab==1?
        <ReportTable/>
        :
        <DownloadPage/>
      }
      </Paper>
        </div>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Typography align='center' variant='h6'>WELCOME {String(name).toUpperCase()}</Typography>
        {
          temp==0?
          <Templates  onTemp1={()=>{setTemp(1)}} onTemp2={()=>{setTemp(2)}} onTemp3={()=>{setTemp(3)}}/>
          :temp==1?
          <EmailTemp back={()=>{setTemp(0)}}/>
          :temp==2?
          <OtherTemp back={()=>{setTemp(0)}} type='acknowledgement'/>
          :
          <OtherTemp back={()=>{setTemp(0)}} type='feedback'/>
        }
        
      </TabPanel>
      <TabPanel value={value} index={5}>
         <Typography align='center' variant='h6'>Notification Template</Typography>
         <Paper style={{padding:'2rem'}}>
          <NotTemp/>
         </Paper>
      
      </TabPanel>
      
   </div>
    
    </div>
  );
}
